// Models offered for static analysis and extraction.
//
// Deliberately NOT the video picker's list. A static sends one still image, so
// both stages need a 'vision' model; the backend's staticAnalysisService calls
// assertVisionModel and refuses anything else rather than sending a request that
// would silently arrive with no image attached. Offering Gemini or Qwen here —
// registered as modality 'video' — would put a guaranteed failure in the menu.
//
// Mirrors sbly-dash-collector src/llm/models.js; keep the two in sync.

export interface StaticModelOption {
  value: string;
  label: string;
  hint: string;
}

export const STATIC_MODEL_OPTIONS: StaticModelOption[] = [
  // Costs are measured, not quoted: one 1254x1568 ad through 1a + 1b.
  { value: 'claude-sonnet-5', label: 'Sonnet 5', hint: '~$0.06 and ~40s per ad — cheapest and fastest' },
  { value: 'claude-opus-5', label: 'Opus 5', hint: '~$0.28 and ~200s per ad — most capable' },
  { value: 'claude-opus-4-8', label: 'Opus 4.8', hint: 'Previous flagship' },
  { value: 'claude-sonnet-4-6', label: 'Sonnet 4.6', hint: '~$0.08 per ad — superseded by Sonnet 5' },
  { value: 'claude-haiku-4-5-20251001', label: 'Haiku 4.5', hint: 'Fast and cheap; use for bulk passes' },
];

// The backend's stage defaults, repeated so the dialog opens on what would run
// anyway if the picker were left alone.
export const DEFAULT_STATIC_ANALYSIS_MODEL = 'claude-sonnet-5';

